import React, {Fragment, useContext} from "react";
import {ApiUtility} from "../common/ApiUtility";
import {useModelCreateEngine} from "../common/hooks/useModelCreateEngine";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {BrokerForm} from "./BrokerForm";
import {GlobalContext} from "../admin-frame/AdminFrame";

export let CreateBrokerPage = function () {
    const context = useContext(GlobalContext);
    const modelCreateEngine = useModelCreateEngine(
        ApiUtility.createBroker,
        'broker',
        () => context.navigator.goBack()
    );

    return (
        <Fragment>
            <ConditionalRenderer if={modelCreateEngine.dataStore.data().loading} renderer={() => (
                <OverlayLoadingIndicator/>
            )}/>
            <BrokerForm
                save={modelCreateEngine.createModel}
                cancel={() => context.navigator.goBack()}
                isNew={true}
            />
        </Fragment>
    );
};
